import { defineMessages } from 'react-intl';

export const messages: {
	for: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'townsquare.api.goal-state.archived': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'townsquare.api.goal-state.at-risk': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'townsquare.api.goal-state.cancelled': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'townsquare.api.goal-state.completed': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'townsquare.api.goal-state.off-track': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'townsquare.api.goal-state.on-track': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'townsquare.api.goal-state.paused': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'townsquare.api.goal-state.pending': {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	for: {
		id: 'dynamic-cards-search-page.atlas.for',
		defaultMessage: 'for',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	'townsquare.api.goal-state.archived': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.archived',
		defaultMessage: 'Archived',
		description:
			'Archived status label for atlas goal that is shown as part of the metadata below the atlas title in the search results, for example "Project • ATLAS-123 • Archived"',
	},
	'townsquare.api.goal-state.off-track': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.off-track',
		defaultMessage: 'Off track',
		description:
			'Off track status label for atlas goal that is shown as part of the metadata below the atlas title in the search results, for example "Project • ATLAS-123 • Off track for August"',
	},
	'townsquare.api.goal-state.at-risk': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.at-risk',
		defaultMessage: 'At risk',
		description:
			'At risk status label for atlas goal that is shown as part of the metadata below the atlas title in the search results, for example "Project • ATLAS-123 • At risk for August"',
	},
	'townsquare.api.goal-state.on-track': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.on-track',
		defaultMessage: 'On track',
		description:
			'On track status label for atlas goal that is shown as part of the metadata below the atlas title in the search results, for example "Project • ATLAS-123 • On track for August"',
	},
	'townsquare.api.goal-state.pending': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.pending',
		defaultMessage: 'Pending',
		description:
			'Pending status label for atlas goal that is shown as part of the metadata below the atlas title in the search results, for example "Project • ATLAS-123 • Pending"',
	},
	'townsquare.api.goal-state.paused': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.paused',
		defaultMessage: 'Paused',
		description:
			'Paused status label for atlas goal that is shown as part of the metadata below the atlas title in the search results, for example "Project • ATLAS-123 • Paused"',
	},
	'townsquare.api.goal-state.completed': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.completed',
		defaultMessage: 'Completed',
		description:
			'Completed status label for atlas goal that is shown as part of the metadata below the atlas title in the search results, for example "Project • ATLAS-123 • Completed"',
	},
	'townsquare.api.goal-state.cancelled': {
		id: 'dynamic-cards-search-page.townsquare.api.goal-state.cancelled',
		defaultMessage: 'Cancelled',
		description:
			'Cancelled status label for atlas goal that is shown as part of the metadata below the atlas title in the search results, for example "Project • ATLAS-123 • Cancelled"',
	},
});
